import {NeobuqModification} from "@/model/Neobuq/NeobuqModifications";
import ModificationsRepo from "@/repositories/neobuqModifications/ModificationsRepo";
import store from "@/store/index";


class ModificationService{

    private static instance: ModificationService;
    private modificationRepo: any;
    private modifications: Map<string, Array<NeobuqModification>>;

    private constructor() {
        //console.log("ModificationService - constructor");
        this.modificationRepo = new ModificationsRepo()
        this.modifications = new Map<string, Array<NeobuqModification>>();
    }

    public static getInstance(): ModificationService {
        if (!ModificationService.instance) {
            ModificationService.instance = new ModificationService();
        }
    
        return ModificationService.instance;
    }

    public createModification(shipId, name, description) {
        //console.log("ModificationService - createModification" + shipId)
        return this.modificationRepo.createModification(shipId, name, description);
    }

    public selectedModification(modification) {
        //console.log("Modificada la configuración", modification);
        store.commit("SET_SHIPS_CURRENT_MODIFICATION", modification);
    }

    public getModificationsForShip(ship) {
        //console.log("ModificationService - getModificationsForShip", ship.id)
    
        // Buscamos las modificaciones del buque
        const modifications: Array<NeobuqModification> | undefined = this.modifications.get(ship.id);
        if (!modifications) {
          //console.log("ModificationService - Detectamos que no tenemos modificaciones")
          this.modificationRepo.getModificationsForShip(ship, this);
        } else {
          //console.log("ModificationService - Detectamos que ya tenemos modificaciones")
          ship.modifications = modifications;
        }
    }

    public addNewModificationFromRepo(ship, modificationId, modificationObj) {
        //console.log("ModificationService - addNewModificationFromRepo", modificationId, modificationObj)
        const modificationElement = this.getModificationObjFromRepo(modificationId, modificationObj);
    
        ship.modifications.push(modificationElement);
    
        this.modifications.set(ship.id, ship.modifications);
    
       // ShipService.getInstance().calcAttainedFromConfigurations(ship.id);
    
       // ShipPartService.getInstance().getShipPartFromConfiguration(ship, configurationId);
    
       // EconomicService.getInstance().getEconomicData(ship, configurationElement as Configuration);
    }

    public modifyModificationFromRepo(ship, modificationId, modificationObj) {

        //console.log("ModificationService-modifyModificationFromRepo", ship, modificationId, modificationObj);
        const modificationElement = this.getModificationObjFromRepo(modificationId, modificationObj);

        //console.log("HOLAAAAAAA MODIFICACION modificationElement")
        //console.log(modificationElement)

        const index = ship.modifications.findIndex((modifications) => modifications.id === modificationId);
        if (index !== -1) {
            ship.modifications[index] = modificationElement;
        }

        this.modifications.set(ship.id, ship.modifications);

        if (modificationId === store.getters.currentModification.id) {
            //const oldObj = store.getters.currentModification;
      
           /* shipPartsElements.forEach((configChild) => {
              configurationElement[configChild] = oldObj[configChild];
            });*/
      
            //configurationElement["economicData"] = oldObj["economicData"];
      

            //EN ESTE PUNTO SE BORRAN LOS VALORES DE 'actualFuelEU' y listFuelEU Y SE PONEN A 'UNDEFINED'
            //console.log("Cambiamos la modificación porque está en edición", modificationElement);
            store.commit("SET_SHIPS_CURRENT_MODIFICATION", modificationElement);
        }
    }

    public removeModificationFromRepo(ship, modificationId) {
        const pos = ship.modifications.map((val) => val.id).indexOf(modificationId);
        if (pos >= 0) {
          ship.modifications.splice(pos, 1);
        }
    }

    public saveModification(shipId: string, modification: NeobuqModification) {
        //console.log("ModificationService - saveModification", shipId, modification.id, modification);

        const modificationToSave: any = {
          ...modification,
        };

       // modificationToSave.actualFuelEU = 0

        return this.modificationRepo.saveModification(shipId, modificationToSave);
    }

    public deleteModification(shipId: string, modificationId: string) {
        this.modificationRepo.deleteModification(shipId, modificationId);
    }

    public deleteAllModifications(shipId: string){
        this.modificationRepo.deleteAllModifications(shipId);
    }

    private getModificationObjFromRepo(modificationId, modificationObjRepo) {

        const modificationElement = {
            id: modificationId,
            name : modificationObjRepo.name,
            description : modificationObjRepo.description,
            type : modificationObjRepo.type,
            fuelSelected : modificationObjRepo.fuelSelected,
            personalizedPercentage : modificationObjRepo.personalizedPercentage,
            newFuelConsumption : modificationObjRepo.newFuelConsumption,

            listCII : modificationObjRepo.listCII,
            listETS : modificationObjRepo.listETS,
            listFuelEU : modificationObjRepo.listFuelEU,

            actualCII : modificationObjRepo.actualCII,
            actualETS : modificationObjRepo.actualETS,
            actualFuelEU : modificationObjRepo.actualFuelEU,

            economicData : modificationObjRepo.economicData,
            ecoefficiencyIndices : modificationObjRepo.ecoefficiencyIndices,
        };
        //console.log("modification element " + modificationElement.fuelSelected)
        return modificationElement;
    }
}

export default ModificationService